<div class="popover-container">
  <div class="dimmer"></div>
  <div class="popover" [ngClass]="size">
    <div class="header-container">
      <div class="mainHeader">
      <div class="popover-header displayFlex">
        <span *ngIf="mergerModal" class="cursor-pointer mr-16">
            <img src="assets/back-navigation.svg" alt="" (click)="onCloseClick()">
        </span>
        {{titleText}}
        <ng-content select="[popover-header]"></ng-content>
      </div>
      <div  *ngIf="!mergerModal && !policyPopup" (click)="onCloseClick()" class="popover-close">
        <img src="assets/images/cancel_24.svg" alt="">
      </div>
      </div>
      <div class="subHeaderText" *ngIf="sendHeader">
       {{subheaderText}}
      </div>
    </div>
    
    <div class="popover-content overflow-y-auto" [ngClass]="{'content-scrollable': scrollable, 'full-height': fullHeight}">
        <ng-content select="[popover-content]"></ng-content>
    </div>
    <div class="popover-actions">
        <ng-content select="[popover-actions]"></ng-content>
    </div>
  </div>
</div>
